export const TRANSLATIONS = {
  en: {
    "Accessibility Menu": "Accessibility Menu",
    "Reset settings": "Reset settings",
    "Reset All Settings": "Reset All Settings",
    "Close": "Close",
    "Content Adjustments": "Content Adjustments",
    "Adjust Font Size": "Adjust Font Size",
    "Highlight Title": "Highlight Title",
    "Highlight Links": "Highlight Links",
    "Readable Font": "Readable Font",
    "Color Adjustments": "Color Adjustments",
    "Invert Colors": "Invert Colors",
    "Light Contrast": "Light Contrast",
    "Dark Contrast": "Dark Contrast",
    "High Contrast": "High Contrast",
    "High Saturation": "High Saturation",
    "Low Saturation": "Low Saturation",
    "Monochrome": "Monochrome",
    "Tools": "Tools",
    "Reading Guide": "Reading Guide",
    "Stop Animations": "Stop Animations",
    "Big Cursor": "Big Cursor",
    "Increase Font Size": "Increase Font Size",
    "Decrease Font Size": "Decrease Font Size",
    "Letter Spacing": "Letter Spacing",
    "Line Height": "Line Height",
    "Font Weight": "Font Weight",
    "Dyslexia Font": "Dyslexia Font",
    "Language": "Language",
    "Open Accessibility Menu": "Open Accessibility Menu",
    "Hide Images": "Hide Images",
    "Skip to accessibility menu": "Skip to accessibility menu",
    "Accessibility Report": "Accessibility Report",
    "Run Accessibility Check": "Run Accessibility Check",
    "Loading...": "Loading...",
    "Analyzing page...": "Analyzing page...",
    "Critical": "Critical",
    "Serious": "Serious",
    "Moderate": "Moderate",
    "Minor": "Minor",
    "Violations Found": "Violations Found",
    "No Issues Found": "No Issues Found",
    "Element": "Element",
    "Issue": "Issue",
    "How to Fix": "How to Fix",
    "Close Report": "Close Report",
    "Passed Tests": "Passed Tests",
    "Items Need Review": "Items Need Review",
    "Annotations": "Annotations",
    "Text to Speech": "Text to Speech",
    "Text to Speech On": "Text to Speech On",
    "Text to Speech Off": "Text to Speech Off",
    "Simplify Layout": "Simplify Layout",
    "Play": "Play",
    "Pause": "Pause",
    "Stop": "Stop",
    "Loading voice...": "Loading voice...",
    "Reading...": "Reading...",
    "All Languages": "All Languages",
    "Search language": "Search language",
    "Font Size": "Font Size",
    "Contrast": "Contrast",
    "Saturation": "Saturation",
    "Accessibility": "Accessibility"
  },
  ne: {
    "Accessibility Menu": "पहुँच मेनु",
    "Reset settings": "सेटिङ रिसेट गर्नुहोस्",
    "Reset All Settings": "सबै सेटिङ रिसेट गर्नुहोस्",
    "Close": "बन्द गर्नुहोस्",
    "Content Adjustments": "सामग्री समायोजन",
    "Adjust Font Size": "फन्ट आकार समायोजन",
    "Highlight Title": "शीर्षक हाइलाइट",
    "Highlight Links": "लिङ्क हाइलाइट",
    "Readable Font": "पठनीय फन्ट",
    "Color Adjustments": "रङ समायोजन",
    "Invert Colors": "रङ उल्टाउनुहोस्",
    "Light Contrast": "हल्का कन्ट्रास्ट",
    "Dark Contrast": "गाढा कन्ट्रास्ट",
    "High Contrast": "उच्च कन्ट्रास्ट",
    "High Saturation": "उच्च संतृप्तता",
    "Low Saturation": "कम संतृप्तता",
    "Monochrome": "एकरङी",
    "Tools": "उपकरणहरू",
    "Reading Guide": "पठन सहायक",
    "Stop Animations": "एनिमेसन रोक्नुहोस्",
    "Big Cursor": "ठूलो कर्सर",
    "Increase Font Size": "फन्ट आकार बढाउनुहोस्",
    "Decrease Font Size": "फन्ट आकार घटाउनुहोस्",
    "Letter Spacing": "अक्षर दूरी",
    "Line Height": "लाइन उचाइ",
    "Font Weight": "फन्ट वजन",
    "Dyslexia Font": "डिस्लेक्सिया फन्ट",
    "Language": "भाषा",
    "Open Accessibility Menu": "पहुँच मेनु खोल्नुहोस्",
    "Hide Images": "तस्बिर लुकाउनुहोस्",
    "Skip to accessibility menu": "पहुँच मेनुमा जानुहोस्",
    "Accessibility Report": "पहुँच प्रतिवेदन",
    "Run Accessibility Check": "पहुँच जाँच चलाउनुहोस्",
    "Loading...": "लोड हुँदैछ...",
    "Analyzing page...": "पृष्ठ विश्लेषण हुँदैछ...",
    "Critical": "गम्भीर",
    "Serious": "साँघुरो",
    "Moderate": "मध्यम",
    "Minor": "सामान्य",
    "Violations Found": "उल्लंघनहरू फेला परे",
    "No Issues Found": "कुनै समस्या फेला परेन",
    "Element": "तत्व",
    "Issue": "समस्या",
    "How to Fix": "कसरी ठीक गर्ने",
    "Close Report": "प्रतिवेदन बन्द गर्नुहोस्",
    "Passed Tests": "पास भएका परीक्षणहरू",
    "Items Need Review": "समीक्षा आवश्यक वस्तुहरू",
    "Annotations": "टिप्पणीहरू",
    "Text to Speech": "पाठ वाचन",
    "Text to Speech On": "पाठ वाचन सक्रिय",
    "Text to Speech Off": "पाठ वाचन निष्क्रिय",
    "Simplify Layout": "लेआउट सरल बनाउनुहोस्",
    "Play": "प्ले",
    "Pause": "पज",
    "Stop": "रोक्नुहोस्",
    "Loading voice...": "आवाज लोड हुँदैछ...",
    "Reading...": "पढिँदैछ...",
    "All Languages": "सबै भाषाहरू",
    "Search language": "भाषा खोज्नुहोस्",
    "Font Size": "फन्ट आकार",
    "Contrast": "कन्ट्रास्ट",
    "Saturation": "संतृप्तता",
    "Accessibility": "पहुँचयोग्यता"
  }
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English (English)' },
  { code: 'ne', label: 'नेपाली (Nepali)' }
];
